import React, { useCallback } from 'react'

import Card from 'components/Card'
import { Checkbox } from 'components/forms'
import { CardHeader, MainContainer, MainInnerContainer } from 'components/Tree/nodes/common'

const Department = ({ children, label, status, toggleActive, cardsInRow, isSelected, isCheckable, activeLeafCount, leafCount, handleSelect, showLeafCount, inverted, checkOnSelect }) => {
	const CardBodyComponent = useCallback(({ children: cardBodyChildren }) => cardBodyChildren, [])
	return(
		<MainContainer xs={Math.ceil(12 / cardsInRow)}>
			<Card
				BodyComponent={CardBodyComponent}
				HeaderComponent={headerProps => (
					<CardHeader onClick={handleSelect} isSelected={isSelected} isSelectable={checkOnSelect} {...headerProps}>
						{isCheckable ? <Checkbox
							noForm
							stopPropagation={true}
							onChange={toggleActive}
							checked={status === 'ACTIVE'}
							indeterminate={status === 'PARTIAL_ACTIVE'}
							label={label}
							inline
							styleInverted
						/> : label}
						{showLeafCount && <h5>{`${activeLeafCount}/${leafCount}`}</h5>}
					</CardHeader>
				)}
			>
				<MainInnerContainer inverted={inverted}>
					{children}
				</MainInnerContainer>
			</Card>
		</MainContainer>
	)
}

export default Department
